/// <reference path="./global.d.ts" />

class PupmdHeroGalleryV2 extends HTMLElement {
  /** @type {InstanceType<typeof Swiper> | null} */
  #thumbSwiper = null;

  /** @type {InstanceType<typeof Swiper> | null} */
  #mainSwiper = null;

  /** @type {ReturnType<typeof setTimeout> | null} */
  #initTimer = null;

  connectedCallback() {
    this.#init();
  }

  disconnectedCallback() {
    if (this.#initTimer !== null) {
      clearTimeout(this.#initTimer);
      this.#initTimer = null;
    }

    if (this.#mainSwiper) {
      this.#mainSwiper.destroy(true, true);
      this.#mainSwiper = null;
    }

    if (this.#thumbSwiper) {
      this.#thumbSwiper.destroy(true, true);
      this.#thumbSwiper = null;
    }
  }

  #init() {
    const thumbsElement = this.querySelector('[data-gallery-thumbs]');
    const mainElement = this.querySelector('[data-gallery-main]');

    if (!thumbsElement || !mainElement) return;

    if (typeof Swiper === 'undefined') {
      this.#initTimer = setTimeout(() => {
        this.#initTimer = null;
        this.#init();
      }, 120);
      return;
    }

    const isRTL = document.documentElement.dir === 'rtl';

    this.#thumbSwiper = new Swiper(thumbsElement, {
      direction: 'vertical',
      spaceBetween: 8,
      slidesPerView: 5,
      freeMode: true,
      watchSlidesProgress: true,
      speed: 500,
      rtl: isRTL,
      breakpoints: {
        0: {
          direction: 'horizontal',
          slidesPerView: 5,
        },
        1021: {
          direction: 'vertical',
          slidesPerView: 5,
        },
      },
    });

    this.#mainSwiper = new Swiper(mainElement, {
      spaceBetween: 15,
      loop: true,
      speed: 700,
      autoHeight: true,
      rtl: isRTL,
      preloadImages: false,
      watchSlidesProgress: true,
      slideToClickedSlide: true,
      thumbs: {
        swiper: this.#thumbSwiper,
      },
    });
  }
}

if (!customElements.get('pupmd-hero-gallery-v2')) {
  customElements.define('pupmd-hero-gallery-v2', PupmdHeroGalleryV2);
}
